import { ScalePrefix } from './constants';
import { scaleVisitor } from './visitors';
import { Literal } from 'vega-expression';
import { isFunction, isString, stringValue } from 'vega-util';
export function getScale(name, ctx) {
  var s;
  return isFunction(name) ? name : isString(name) ? (s = ctx.scales[name]) && s.value : undefined;
}
export function internalScaleFunctions(codegen, fnctx, visitors) {
  // add helper method to the 'this' expression function context
  fnctx.__bandwidth = function (s) {
    return s && s.bandwidth ? s.bandwidth() : 0;
  };

  // register AST visitors for internal scale functions
  visitors._bandwidth = scaleVisitor;
  visitors._range = scaleVisitor;
  visitors._scale = scaleVisitor;

  // resolve scale reference directly to the signal hash argument
  var ref = function ref(arg) {
    return '_[' + (arg.type === Literal ? stringValue(ScalePrefix + arg.value) : stringValue(ScalePrefix) + '+' + codegen(arg)) + ']';
  };

  // define and return internal scale function code generators
  // these internal functions are called by mark encoders
  return {
    _bandwidth: function _bandwidth(args) {
      return "this.__bandwidth(".concat(ref(args[0]), ")");
    },
    _range: function _range(args) {
      return "".concat(ref(args[0]), ".range()");
    },
    _scale: function _scale(args) {
      return "".concat(ref(args[0]), "(").concat(codegen(args[1]), ")");
    }
  };
}